import React from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import DynamicForm from '../components/DynamicForm';
import { toast } from 'react-toastify';
import AppLayout from '../components/AppLayout';
import { routes } from '../lib/routes';

export default function FormularioDinamico() {
  const { protocolo_id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: formulario, isLoading } = useQuery(
    ['formulario', protocolo_id],
    () => api.get(`/formularios/por-protocolo/${protocolo_id}`).then((r) => r.data)
  );

  const mutation = useMutation(
    (values) => api.post('/formularios/respostas', { formulario_id: formulario?.id, protocolo_id, respostas: values }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['protocolo', protocolo_id]);
        toast.success('Formulario salvo com sucesso.');
        navigate(routes.protocolo(protocolo_id));
      },
      onError: (err) => toast.error(err.response?.data?.error || 'Erro ao salvar.')
    }
  );

  const campos = formulario?.campos;

  const initialValues = campos?.reduce((acc, campo) => ({ ...acc, [campo.id]: '' }), {}) || {};
  const validationSchema = Yup.object(
    campos?.filter(c => c.obrigatorio).reduce((acc, c) => ({ ...acc, [c.id]: Yup.string().required('Obrigatório') }), {}) || {}
  );

  return (
    <AppLayout
      title={formulario?.nome || 'Formulario dinamico'}
      actions={
        <Link to={routes.protocolo(protocolo_id)} className="sispro-btn sispro-btn--secondary sispro-btn--sm">
          Voltar ao protocolo
        </Link>
      }
    >
      <div className="panel max-w-3xl">
        {isLoading ? (
          <p className="sispro-empty py-8">Carregando formulario...</p>
        ) : !campos?.length ? (
          <p className="sispro-empty py-8">Nenhum campo configurado para este tipo de processo.</p>
        ) : (
          <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={mutation.mutate}>
            <Form>
              <DynamicForm campos={campos} />
              <div className="flex flex-wrap gap-3 mt-6">
                <button type="submit" disabled={mutation.isLoading} className="sispro-btn sispro-btn--primary">
                  {mutation.isLoading ? 'Salvando...' : 'Salvar respostas'}
                </button>
                <Link to={routes.protocolo(protocolo_id)} className="sispro-btn sispro-btn--secondary">
                  Cancelar
                </Link>
              </div>
            </Form>
          </Formik>
        )}
      </div>
    </AppLayout>
  );
}
